interface PrintContentProps {
  text: string;
  title: string;
}

export const printContent = ({ text, title }: PrintContentProps) => {
  const cleanContent = text || "";

  const printWindow = window.open("", "_blank");
  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <link rel="stylesheet" href="/print.css">
      </head>
      <body>
        <div class="content-box">
          <div class="content-text">
            ${cleanContent}
          </div>
        </div>

        <script>
          window.onload = function () {
            window.print();
          };
          window.onafterprint = function () {
            window.close();
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
  }
};
